module.exports = __webpack_public_path__ + "static/media/kibanalogo.832e2196.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/kibanalogo.png
// module id = 830
// module chunks = 0